import cn from 'clsx'
import LineBedIcon from 'components/Luxkit/Icons/line/LineBedIcon'
import SolidPricetagAltIcon from 'components/Luxkit/Icons/solid/SolidPricetagAltIcon'
import BodyTextBlock from 'components/Luxkit/TextBlocks/BodyTextBlock'
import { rem } from 'polished'
import React, { useState } from 'react'
import styled from 'styled-components'

const MarkerContainer = styled.div`
  position: relative;
  border-radius: ${(props) => props.theme.borderRadius.M};
  padding: ${rem(4)} ${rem(8)};
  background-color: ${(props) => props.theme.palette.neutral.eight};
  box-shadow: ${(props) => props.theme.shadow.bottom.small};
  border: 1px solid ${(props) => props.theme.palette.neutral.four};

  &.active,
  :hover
  {
    font-weight: ${(props) => props.theme.font.primary.weight.bold};  
    background-color: ${(props) => props.theme.palette.primary.darkest};
    border: 1px solid ${(props) => props.theme.palette.primary.darkest};
    color: ${(props) => props.theme.palette.primary.lightest};
  }
`

interface Props {
  isActive: boolean;
  label?: string;
  discount?: number;
  isVisited: boolean;
}

function PropertyPriceMarker(props: Props) {
  const {
    isActive,
    label,
    discount,
    isVisited,
  } = props
  const [isHovered, setIsHovered] = useState(false)
  const active = isActive || isHovered
  const icon = discount && !!label && <SolidPricetagAltIcon size={active ? 'M' : 'S'} colour="highlight-primary-normal" />

  return (
    <MarkerContainer
      className={cn({
        active: isActive,
        visited: isVisited,
      })}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {label && <BodyTextBlock startIcon={icon} variant={active ? 'large' : 'medium'}>
        {label}
      </BodyTextBlock>}
      {!label && <LineBedIcon size="S" />}
    </MarkerContainer>
  )
}

export default PropertyPriceMarker
